import { httpClient } from 'utils/httpClient';
import {
  ConfiguracionItem, ConfigClave, ConfiguracionPayload,
  ConfiguracionHistorial,
} from 'types/configuracion.types';

export const configuracionService = {
  async listarTodas(): Promise<ConfiguracionItem[]> {
    try {
      return await httpClient.get<ConfiguracionItem[]>('/configuraciones');
    } catch { return []; }
  },

  async actualizar(clave: ConfigClave, valor: string): Promise<ConfiguracionItem> {
    return httpClient.put<ConfiguracionItem>(`/configuraciones/${clave}`, { valor } as ConfiguracionPayload);
  },

  async obtener(clave: ConfigClave): Promise<ConfiguracionItem | null> {
    try {
      return await httpClient.get<ConfiguracionItem>(`/configuraciones/${clave}`);
    } catch { return null; }
  },

  /** GET /configuraciones/historial — solo ADMIN */
  async getHistorial(): Promise<ConfiguracionHistorial[]> {
    return httpClient.get<ConfiguracionHistorial[]>('/configuraciones/historial');
  },

  /** GET /configuraciones/{clave}/historial — solo ADMIN */
  async getHistorialClave(clave: ConfigClave): Promise<ConfiguracionHistorial[]> {
    return httpClient.get<ConfiguracionHistorial[]>(`/configuraciones/${clave}/historial`);
  },
};
